export enum MultiPaymentSelectionContainerDataHooks {
  MAIN = 'multi-payment-selection-container-main',
  SINGLE = 'multi-payment-selection-container-single',
}
